import { ProgramModule_mkProgram, ProgramModule_run } from "./fable_modules/Fable.Elmish.3.1.0/program.fs.js";
import { Program_withReactSynchronous } from "./fable_modules/Fable.Elmish.React.3.0.1/react.fs.js";
import { init } from "./Model.fs.js";
import { update } from "./Update.fs.js";
import { view } from "./View.fs.js";

ProgramModule_run(Program_withReactSynchronous("app-container", ProgramModule_mkProgram(init, (msg, state) => update(msg, state), (state_1, dispatch) => view(state_1, dispatch))));

